export default {
	identities(state) {
		return state.user ? state.user.identities : [];
	}
};